import { compose, pure } from 'recompose';
import { withNamespaces } from 'react-i18next';
import OnlineStatusLabel from './onlineStatusLabel';

const enhance = compose(
  pure,
  withNamespaces(['common']),
);
export default enhance(OnlineStatusLabel);
